<template>
  <div
    :class="{ 'swiping-left': swiping && swipingDirection === 'left' }"
    @touchstart.passive="handleTouchStart"
    @touchmove.passive="handleTouchMove"
    @touchend.passive="handleTouchEnd"
  >
    <div class="swipe-indicator swipe-indicator--left">
      <i class="fas fa-step-forward"></i>
    </div>
    <slot />
  </div>
</template>

<script>
// Horizontal swipe detector; emits swipe-left / swipe-right.
const MIN_SWIPE_DISTANCE = 80;
// Maximum vertical movement allowed for a horizontal swipe.
const MAX_VERTICAL_OFFSET = 100;

export default {
  name: 'SwipeArea',
  data() {
    return {
      swiping: false,
      swipingDirection: null // 'left', 'right', or null
    };
  },
  created() {
    this.touchStartX = 0;
    this.touchStartY = 0;
  },
  methods: {
    handleTouchStart(event) {
      this.touchStartX = event.changedTouches[0].screenX;
      this.touchStartY = event.changedTouches[0].screenY;
      this.swiping = true;
      this.swipingDirection = null;
    },

    handleTouchMove(event) {
      if (!this.swiping) return;
      const horizontalDistance = event.changedTouches[0].screenX - this.touchStartX;
      if (Math.abs(horizontalDistance) > 20) {
        this.swipingDirection = horizontalDistance > 0 ? 'right' : 'left';
      } else {
        this.swipingDirection = null;
      }
    },

    handleTouchEnd(event) {
      if (!this.swiping) return;
      const horizontalDistance = event.changedTouches[0].screenX - this.touchStartX;
      const verticalDistance = Math.abs(event.changedTouches[0].screenY - this.touchStartY);
      if (verticalDistance <= MAX_VERTICAL_OFFSET && Math.abs(horizontalDistance) >= MIN_SWIPE_DISTANCE) {
        this.$emit(horizontalDistance > 0 ? 'swipe-right' : 'swipe-left');
      }
      this.swiping = false;
      this.swipingDirection = null;
    }
  }
};
</script>

<style scoped>
.swipe-indicator {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  background: var(--accent);
  color: var(--accent-ink);
  border-radius: var(--r-pill);
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 30;
}

.swipe-indicator--left {
  left: 20px;
}

.swipe-indicator i {
  font-size: 24px;
}

.swiping-left .swipe-indicator--left {
  opacity: 0.9;
}
</style>
